import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, text, dark = false, align = "left" }) => (
  <Reveal
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    data-testid={undefined}
  >
    {overline && (
      <p
        className={`text-xs font-bold uppercase tracking-[0.22em] ${
          dark ? "text-electric-bright" : "text-electric"
        }`}
      >
        {overline}
      </p>
    )}
    <h2
      className={`mt-4 font-display text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl ${
        dark ? "text-white" : "text-slate-900"
      }`}
    >
      {title}
    </h2>
    {text && (
      <p
        className={`mt-5 text-base leading-relaxed md:text-lg ${
          dark ? "text-slate-400" : "text-slate-600"
        }`}
      >
        {text}
      </p>
    )}
  </Reveal>
);
